module.exports = __webpack_public_path__ + "static/media/messages-icon.94b02d13.svg";